"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_redux_1 = require("react-redux");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const models_1 = require("@completeanatomy/models");
const models_panel_1 = require("@completeanatomy/models-panel");
function TabRegionsIcon(props) {
    const { height, className } = props;
    const modelType = (0, react_redux_1.useSelector)(models_1.getModelType);
    const mode = modelType === bridge_schema_1.ModelType.Male || modelType === bridge_schema_1.ModelType.Female
        ? models_panel_1.BodyRegionsIconMode.Single
        : models_panel_1.BodyRegionsIconMode.Double;
    return ((0, jsx_runtime_1.jsx)(models_panel_1.BodyRegionsIcon, { height: height, mode: mode, className: className, showSexIcon: false }));
}
exports.default = TabRegionsIcon;
